<template>
  <div class="content-wrapper">
    <vx-card class="p-0">
      <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
        <vs-tab label="Reminder">
          <h1 class="">Reminder</h1>
          <vs-row class="my-4">
            <vs-col vs-lg="12" vs-sm="12">
              <div class="d-flex">
                <div  style="max-width: 100%;  overflow-x: auto;    overflow: visible;">
                  <vs-card>
                    <div class="mb-3 text-left">Messages</div>
                    <ul class="statistic">
                      <li>
                        <h3 class="text-left mb-0">0</h3>
                      </li>
                    </ul>
                  </vs-card>
                </div>
                <div class="px-4" style="max-width: 100%; overflow-x: auto;    overflow: visible;">
                  <vs-card>
                    <div class="mb-3 text-left">Sent</div>
                    <ul class="statistic">
                      <li>
                        <h3 class="text-left mb-0">0</h3>
                      </li>
                    </ul>
                  </vs-card>
                </div>
                <div style="max-width: 100%; overflow-x: auto;overflow: visible;">
                  <vs-card>
                    <div class="mb-3 text-left">Scheduled</div>
                    <ul class="statistic">
                      <li>
                        <div class="d-flex items-center">
                          <h3 class="mb-0 text-left">0</h3>
                          <div class="ml-3 text-xs">Today</div>
                        </div>
                      </li>
                      <li>
                        <div class="d-flex">
                          <h3 class="mb-0 text-left">0</h3>
                          <div class="ml-3 text-xs">Later</div>
                        </div>
                      </li>
                    </ul>
                  </vs-card>
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12">
              <vs-button
                :to="`/events/` + this.e + `/attendee_messages/add`"
                color="primary"
                type="filled"
                >Add New</vs-button
              >
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12">
              <div class="d-flex flex-end" style="justify-content: flex-end">
                <div class="ml-auto mr-3">
                  <vs-input
                    id="search"
                    class="inputx"
                    placeholder="Search..."
                    v-model="search"
                    v-on:input="debounceInput"
                  />
                </div>
                <b-dropdown size="sm" text="Actions" variant="outline-danger">
                  <b-dropdown-item
                    v-for="(item, index) in [{ text: 'test' }]"
                    :key="index"
                    @click="onAction(data.item, item)"
                  >
                    <i :class="item.icon" class="cursor-pointer"></i>
                    {{ item.text }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </vs-col>
          </vs-row>
          <template>
            <vx-card>
              <div style="display: flex; ">
                <div>Scheduled</div>
                <div>
                  <div>Reminder to Join the Event</div>
                  <div>All Attendees · 1 day before the event at 6:00 PM</div>
                  <div>reminder</div>
                </div>
                <div>email</div>
                <div>
                  <div>
                    edit
                  </div>
                  <div>
                    duplicate
                  </div>
                </div>
              </div>
            </vx-card>
          </template>
          <div v-if="showPagination" class="mt-3 text-right">
            <vs-pagination
              :total="Math.ceil(totalRows / 30)"
              v-model="currentPage"
              prev-icon="arrow_back"
              next-icon="arrow_forward"
            ></vs-pagination>

            <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import Service from "@/services";
import SummaryTable from "@/components/soldoutt/SummaryTable.vue";

import { mapState } from "vuex";
export default {
  components: {
    SummaryTable,
  },
  data: () => ({
    columns: [
      { label: "ID", key: "message_id", sortable: false },
      {
        label: "Publish Status",
        key: "publish_status",
        sortable: false,
      },
      {
        label: "Listing Status",
        key: "listing_status",
        sortable: false,
      },
      { label: "Subject", key: "email_subject", sortable: false },
      { label: "Link Type", key: "cta_url_type", sortable: false },
      { label: "URL", key: "cta_url", sortable: false },
      { label: "", key: "action", sortable: false },
    ],
    activeTab: 0,
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    showPagination: true,
    pageOptions: [2, 5, 10, 15, 30, 50],
    stats: {},
  }),
  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },
  created() {},
  mounted() {
    window.addEventListener("keydown", (e) => {
      if (this.remarkDialog == false) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },
  methods: {
    onStatusChanged: _.debounce(function (e) {
      let data = {
        listing_status: e.listing_status,
        publish_status: e.publish_status,
        message_id: e.message_id,
      };
      this.$vs.loading();
      console.log(data);
      Service.AttendeeMessage.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
        }

        this.$vs.loading.close();
      });
    }, 500),
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function (val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
          s: this.$route.query.s,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        Service.AttendeeMessage.gets(params)
          .then((res) => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.list;
            this.log = res.log;

            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1800);
    },
    open(item) {
      this.$router.push(
        "/events/" +
          this.e +
          "/attendee_messages/" +
          item.message_id +
          "/view?e=" +
          this.e +
          "&s=" +
          this.s
      );
    },
  },
};
</script>

<style>
.width-250 {
  width: 250px;
}
.width-300 {
  width: 300px;
}
.width-450 {
  width: 450px;
}
button.dropdown-toggle {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
  border-top-right-radius: 0.2rem !important;
  border-bottom-right-radius: 0.2rem !important;
  border-top-left-radius: 0.2rem !important;
  border-bottom-left-radius: 0.2rem !important;
}
</style>
